import { ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import { put, takeEvery } from 'redux-saga/effects';

import { toDto as employeeToDto } from '../../../../models/adapters/EmployeeAdapter';
import { deleteEmployee, DeleteEmployeeActionType, employeeDeleted, employeeDeleteFailed } from '../../../actions/setting/company/deleteEmployee';
import getAuthenticationToken from '../../getAuthenticationToken';
import getProtectedResponse from '../../getProtectedResponse';

function* deleteEmployeeSaga({ payload }: DeleteEmployeeActionType) {
  const { employee, companyUuid } = payload;
  const token = yield getAuthenticationToken();
  const employeeDto = employeeToDto(employee);
  const response = yield getProtectedResponse(ProtectedServerPlaceEvent.deleteEmployee, token, {
    employee: employeeDto,
  });
  if (!response.error) {
    yield put(employeeDeleted({ employee, companyUuid }));
  } else {
    yield put(employeeDeleteFailed({ employee, companyUuid }));
  }
}

export default function* watchAddEmployeeSaga() {
  yield takeEvery(deleteEmployee, deleteEmployeeSaga);
}
